<template>
<div class="container">
    <div class="row justify-content-center">
        <div class="separator pt-3">
            <div class="content color-fondo"></div>
        </div>
        <div class="gradiente">
            <div class="container">
                <div class="row"><h2 class="display-5 fw-bold text-center pb-5"><a name="about"></a>ACERCA DE MÍ</h2></div>
                <div class="row">
                    <div class="col-sm">
                        <img src="../assets/esteban.png" alt="" class="w-100 img-fluid" style="margin-left: 10%;  margin-top: -10%; margin-bottom: 20%">
                    </div>
                    <div class="col-sm">
                        <p class="texto_base">
                            Programador Web con experiencia en desarrollo Front-End con uso de framework para desarrollo de páginas web como Bootstrap, Vue, Angular y Quasar. Conocimento en programación de aplicaciones de escritorio con lenguaje Java y modelos análiticos con Python.
                        </p>
                        <p class="texto_base">
                            Analista estadístico de datos con experiencia en investigación de mercados. Manejo de bases de datos de diversa naturaleza, enfocadas en su mayoría al análisis multivariante como correspondencias binarias y múltiples, clasificación y segmentación, y análisis predictivo como regresiones lineales y logísticas.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="separator mt-5">
            <div class="content bg-primary bg-opacity-50"></div>
        </div>
        <div class="bg-primary bg-opacity-50 pb-3">
            <div class="container">
              <div class="row justify-content-center align-content-center">
                <h2 class="display-5 fw-bold text-center my-4"><a name="portafolio"></a>PORTAFOLIO</h2>
                <div class="card-group">
                  <div class="col-md-4 col-sm-12">
                      <div class="card m-1 escala" style="border-radius: 20px; box-shadow: 10px 10px 20px grey">
                        <img src="../assets/web.jpg" alt="Card image cap" class="card-img-top" style="border-radius: 20px 20px 0px 0px">
                          <div class="card-body">
                            <h5 class="card-title">Desarrollador Web</h5>
                            <p class="card-text texto_base2">Diseño de páginas, portales y aplicaciones web en el lado del cliente (Front-end).
                                Continuamente aprendiendo y adquiriendo nuevas habilidades en función a las actuales y futuras demandas y tendencias tecnológicas en el campo del desarrollo de aplicaciones web en general.
                            </p>
                            <a class="btn btn-outline-info" data-bs-toggle="modal" data-bs-target="#exampleModal1">Conocer más</a>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-4 col-sm-12">
                      <div class="card m-1 escala" style="border-radius: 20px; box-shadow: 10px 10px 20px grey">
                            <img src="../assets/programacion.jpg" alt="Card image cap" class="card-img-top" style="border-radius: 20px 20px 0px 0px">
                            <div class="card-body">
                                <h5 class="card-title">Aplicaciones de Escritorio</h5>
                                <p class="card-text texto_base2">Diseño de aplicaciones de escritorio con lenguaje Java para ambiente Windows.
                                    Desarrollo de un ejecutable .exe.
                                    Aplicaciones para control de inventario y ventas con respaldo en bases de datos en MySQL.
                                    Desarrollo de un instalador para la correcta ejecución de la aplicación.
                                    Manejo de metodogía Scrum.
                                </p>
                                <a class="btn btn-outline-info" data-bs-toggle="modal" data-bs-target="#exampleModal2">Conocer más</a>
                            </div>
                      </div>
                  </div>
                  <div class="col-md-4 col-sm-12">
                      <div class="card m-1 escala" style="border-radius: 20px; box-shadow: 10px 10px 20px grey">
                            <img src="../assets/datos.jpg" alt="Card image cap" class="card-img-top" style="border-radius: 20px 20px 0px 0px">
                            <div class="card-body">
                                <h5 class="card-title">Analista de Datos con Python</h5>
                                <p class="card-text texto_base2">Análisis de Datos Estadísticos para investigación comercial.
                                  Manejo y desarrollo de modelos análiticos en Machine Learning (Aprendizaje supervisado y Aprendizaje no supervisado).
                                  Especialista en Análisis Multiviariante. Experiencia en SPSS y Excel. Conocimiento en R.
                                </p>
                                <a class="btn btn-outline-info" data-bs-toggle="modal" data-bs-target="#exampleModal3">Conocer más</a>
                            </div>
                      </div>
                  </div>      
                </div>
              </div>
            </div>
        </div>
        <div class="pb-3 bg-secondary bg-opacity-25">
            <h2 class="display-5 fw-bold text-center my-4"><a name="contacto"></a> Contacto</h2>
            <form ref="form" v-on:submit.prevent="sendEmail">
                <div class="mb-3">
                    <label for="formGroupExampleInput" class="form-label texto_base2">Nombre</label>
                    <input type="text" v-model="name" name="name" class="form-control" id="formGroupExampleInput" placeholder="Ingrese su nombre">
                </div>
                <div class="mb-3">
                    <label for="exampleInputEmail1" class="form-label texto_base2">Correo Electrónico</label>
                    <input type="email" v-model="email" name="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Ingrese su correo electrónico">
                </div>
                <div class="mb-3">
                    <label for="exampleFormControlTextarea1" class="form-label texto_base2">Mensaje</label>
                    <textarea name="message" v-model="message" class="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="Escriba su mensaje"></textarea>
                </div>
                <!--<input type="submit" value="Send">-->
            
            <div class="py-5">
               <button type="submit" class="btn btn-lg btn-info">Enviar</button>
            </div>
            </form>
        </div>
    </div>
</div>

<div class="d-flex justify-content-end fixed-bottom mb-5">
    <a class="btn btn-primary mb-5" href="#arriba" role="button">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
          <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
        </svg>
    </a>
</div>


<div class="modal fade" id="exampleModal1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header bg-secondary bg-opacity-25">
        <h5 class="modal-title texto_base" id="exampleModalLabel">Desarrollador Web</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <desarrollador />
      </div>
      <div class="modal-footer bg-secondary bg-opacity-25">
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Cerrar</button>
        <!--<button type="button" class="btn btn-primary">Save changes</button>-->
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="exampleModal2" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header bg-secondary bg-opacity-25">
        <h5 class="modal-title texto_base" id="exampleModalLabel">Programador de Aplicaciones</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <programador />
      </div>
      <div class="modal-footer bg-secondary bg-opacity-25">
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Cerrar</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="exampleModal3" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header bg-secondary bg-opacity-25">
        <h5 class="modal-title texto_base" id="exampleModalLabel">Analista de Datos con Python</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <estadistica />
      </div>
      <div class="modal-footer bg-secondary bg-opacity-25">
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Cerrar</button>
      </div>
    </div>
  </div>
</div>    
</template>

<script>
import Desarrollador from './Desarrollador.vue'
import Estadistica from './Estadistica.vue'
import Programador from './Programador.vue'

import emailjs from 'emailjs-com';

export default {
    name:'Padre',
    components:{
        Desarrollador,
        Programador,
        Estadistica
    },
    data() {
      return {
        name: '',
        email: '',
        message: '',
      }
    },
    methods: {
      sendEmail() {
        try {
          emailjs.sendForm('service_3e925vr', 'template_18dam0m', this.$refs.form,'user_PMUN6vZfoWvAIRXef4Weg',{
            name: this.name,
            email: this.email,
            message: this.message
          })
        }catch(error) {
          console.log({error})
        }
        this.name = '';
        this.email = '';
        this.message = '';
      }
    },
    
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Merriweather+Sans:wght@400;700&display=swap');

.texto_base{
  font-family: 'Merriweather Sans', sans-serif;
  font-size: 18px;
  text-align: justify;
}
.texto_base2{
  font-family: 'Merriweather Sans', sans-serif;
  font-size: 16px;
  text-align: justify;
}
.texto_titulo1{
  font-family: 'Merriweather Sans', sans-serif;
  font-size: 20px;
}

.separator{
    width: 100%;
    overflow: hidden;
    position: relative;
    z-index: 2;
}
.separator .content{
    background-color: rgba(128, 128, 128, 0.2);
    width: 110%;
    height: 80px;
    margin-left: -5%;
    border-top-left-radius: 50%;
    border-top-right-radius: 50%;
}
.color-fondo{
    background-color: rgba(128, 128, 128, 0.2);
}
.gradiente{
    background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(128,128,128,0.2) 57%);
}
.escala:hover {
  transform: scale(1.03);
}
</style>